import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaGavel, FaTimes } from "react-icons/fa";
import {
  AUCTION_COMPARE_ROWS,
  getAuctionCompareDetailHref,
} from "../../utils/auctionCompare.util";

export default function AuctionComparisonModal({ open, auctions = [], onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open || auctions.length < 2) return null;

  return (
    <div className="marketplace-compare-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="marketplace-compare-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="auction-compare-modal-title"
      >
        <header className="marketplace-compare-modal__header">
          <h2 id="auction-compare-modal-title">Auction Comparison</h2>
          <button type="button" className="marketplace-compare-modal__close" onClick={onClose} aria-label="Close">
            <FaTimes aria-hidden />
          </button>
        </header>

        <div className="marketplace-compare-modal__body">
          <table className="marketplace-compare-modal__table">
            <thead>
              <tr>
                <th className="marketplace-compare-modal__attr-head">Attribute</th>
                {auctions.map((auction) => (
                  <th key={auction.auction_id} className="marketplace-compare-modal__product-head">
                    <div className="marketplace-compare-modal__product-title">{auction.product_name}</div>
                    {(auction.seller_company || auction.seller_name) ? (
                      <div className="marketplace-compare-modal__product-company">
                        {auction.seller_company || auction.seller_name}
                      </div>
                    ) : null}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {AUCTION_COMPARE_ROWS.map((row) => (
                <tr key={row.key} className="marketplace-compare-modal__row">
                  <td className="marketplace-compare-modal__attr-cell">{row.label}</td>
                  {auctions.map((auction) => (
                    <td key={`${row.key}-${auction.auction_id}`} className="marketplace-compare-modal__value-cell">
                      {row.getValue(auction)}
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="marketplace-compare-modal__row marketplace-compare-modal__row--actions">
                <td className="marketplace-compare-modal__attr-cell" />
                {auctions.map((auction) => (
                  <td key={`action-${auction.auction_id}`} className="marketplace-compare-modal__value-cell">
                    <Link to={getAuctionCompareDetailHref(auction)} className="marketplace-compare-modal__quote-btn">
                      <FaGavel aria-hidden /> View & Bid
                    </Link>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
